import { RestaurantMenuOutlined } from '@mui/icons-material';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { TransformGroupResult } from 'api/ordering-service/ordering-service.types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GroupsPopover from './groups-popover/groups-popover.component';
import CopyText from 'components/copy-text/copy-text.component';

type GroupsInfoCardProps = {
  drawerData: Partial<TransformGroupResult>;
};

const GroupsInfoCard = ({ drawerData }: GroupsInfoCardProps) => {
  const { t } = useTranslation();

  const isImported: boolean = useMemo(
    () => !!drawerData?.externalId,
    [drawerData?.externalId],
  );

  return (
    <Card
      className="field-container"
      sx={{ mb: 2 }}
      elevation={4}
      data-testid="GroupsInfoCard"
    >
      <CardHeader
        avatar={
          <Avatar
            src={drawerData?.displayInfo[0]?.smallImage?.[0]}
            variant="circular"
            sx={{ width: 50, height: 50 }}
            data-testid="GroupsInfoCard.Avatar"
          >
            <RestaurantMenuOutlined fontSize="large" />
          </Avatar>
        }
        title={
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <Typography variant="h2">{drawerData?.title}</Typography>
            {isImported && (
              <Chip
                label={t('forms.groupsForm.groupCard.chip.label')}
                size="small"
                color="info"
              />
            )}
          </Stack>
        }
        action={<GroupsPopover drawerData={drawerData} />}
      />
      <CardContent>
        <Stack direction="row" alignItems="center">
          <Typography mr={1} variant="h6">
            {t('forms.groupsForm.groupCard.groupId.label')}:
          </Typography>
          <CopyText>{drawerData?.groupId}</CopyText>
        </Stack>
        {!!isImported && (
          <Stack direction="row" alignItems="center" mt={1}>
            <Typography mr={1} variant="h6">
              {t('forms.groupsForm.groupCard.externalId.label')}:
            </Typography>
            <CopyText>{drawerData?.externalId}</CopyText>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default GroupsInfoCard;
